import Vue from 'vue'
import Router from 'vue-router'

// Shared
// import Completed from '@/components/shared/Completed'
// import Aborted from '@/components/shared/Aborted'

// Tasks
// import DigitSpanForwards from '@/components/Tasks/DigitSpanForwards/Root'
// import DigitSpanBackwards from '@/components/Tasks/DigitSpanBackwards/Root'
// import Coding from '@/components/Tasks/Coding/Root'
// import PatternSeparationTask from '@/components/Tasks/PatternSeparationTask/Root'
// import Attention from '@/components/Tasks/Attention/Root'
// import ComplexReactionTime from '@/components/Tasks/ComplexReactionTime/Root'
// import VerbalMemory from '@/components/Tasks/VerbalMemory/Root'
// import VisualMemory from '@/components/Tasks/VisualMemory/Root'

// Dashboard
const Dashboard = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Dashboard/Root'), 'dash')
    })
}

// SHARED COMPONENTS
const Completed = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/shared/Completed'), 'shared')
    })
}

// SHARED COMPONENTS
const Error = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Error'), 'error')
    })
}

const Aborted = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/shared/Aborted'), 'shared')
    })
}

// TASKS
// const Survey = (resolve) => {
//     // The empty array is for specifying other dependencies that need to be loaded.
//     require.ensure([], () => {
//         resolve(require('@/components/Tasks/Survey/Survey'))
//     })
// }
const DigitSpanForwards = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/DigitSpanForwards/Root'))
    })
}
const DigitSpanBackwards = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/DigitSpanBackwards/Root'))
    })
}
const Coding = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/Coding/Root'))
    })
}
const PatternSeparationTask = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/PatternSeparationTask/Root'))
    })
}
const SimpleReactionTime = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/SimpleReactionTime/Root'))
    })
}
const SimpleReactionTimeAudio = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/SimpleReactionTimeAudio/Root'))
    })
}
const ComplexReactionTime = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ComplexReactionTime/Root'))
    })
}
const VerbalMemory = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/VerbalMemory/Root'))
    })
}
const VisualMemory = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/VisualMemory/Root'))
    })
}
const MST = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/MST/Root'))
    })
}
const ANT = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ANT/Root'))
    })
}
const PictureVocabularyTask = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/PictureVocabularyTask/Root'))
    })
}

const iqtest = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/iqt/Root'))
    })
}

const PatternRecognitionTest = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ptr/Root'))
    })
}

const HADS = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/HADS/Root'))
    })
}

const ASRS = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ASRS/Root'))
    })
}

const UPPSP = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/UPPSP/Root'))
    })
}

const RUSSUG = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/RUSSUG/Root'))
    })
}

const AUDIT = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/AUDIT/Root'))
    })
}

const DUDIT = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/DUDIT/Root'))
    })
}

const COBRA = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/COBRA/Root'))
    })
}

const CPFSurvey = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/CPFSurvey/Root'))
    })
}

const BWSurvey = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/BirthWeightSurvey/Root'))
    })
}

const RAND36 = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/RAND36/Root'))
    })
}

const shortpersonalitytest = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/PersonalityTestShort/Root'))
    })
}

const personalitytest = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/PersonalityTestLong/Root'))
    })
}

const GRIT = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/GRIT/Root'))
    })
}

const rewardandpunishment = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/RewardAndPunishment/Root'))
    })
}

const rrq = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/RRQ/Root'))
    })
}

const rrs = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/RRS/Root'))
    })
}

const pretest = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/Pretest/Root'))
    })
}

const posttest = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/Posttest/Root'))
    })
}

const pretestfatigue = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/PretestFatigue/Root'))
    })
}

const posttestfatigue = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/PosttestFatigue/Root'))
    })
}

const Breakpoint = resolve => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/Breakpoint/Root'))
    })
}

const Matrix = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/matrix/Root'))
    })
}

const AddiQoL = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ADDIQOL/Root'))
    })
}

const fingertappingtest = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/FingerTappingTest/Root'))
    })
}
/*
const AudioCheck = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/AudioCheck'), 'dash')
  })
}
const Consent = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Consent'), 'dash')
  })
}
const Done = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Done'), 'dash')
  })
}
const Feedback = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Feedback'), 'dash')
  })
}
const Rules = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Rules'), 'dash')
  })
}
const Task = resolve => {
  // The eAUDITmpty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Task'), 'dash')
  })
}
*/

const Login = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Login'))
    })
}

const CPT = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ContiniousPerformanceTest/Root'))
    })
}

const Stroop = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/Stroop/Root'))
    })
}

const StroopEmotional = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/StroopEmotional/Root'))
    })
}

const CPTMS = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ContiniousPerformanceTestMS/Root'))
    })
}

const CPT10 = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ContiniousPerformanceTest10/Root'))
    })
}

const CPTAUDIO = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ContiniousPerformanceTestAudio/Root'))
    })
}

const CPTAUDIO7 = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/ContiniousPerformanceTestAudio7min/Root'))
    })
}

const SYNSOPPFATNINGBLOKK = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/SynsoppfatningBlokk/Root'))
    })
}

const SYNSOPPFATNINGBLOKKMULTI = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/SynsoppfatningBlokkMulti/Root'))
    })
}

const SYNSOPPFATNINGEVENT = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/Tasks/SynsoppfatningEvent/Root'))
    })
}

const LinkLogin = (resolve) => {
    // The empty array is for specifying other dependencies that need to be loaded.
    require.ensure([], () => {
        resolve(require('@/components/LinkLogin'))
    })
}

const LinkTokenLogin = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/LinkTokenLogin'))
    })
}

const PSST = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/PSST/Root'))
    })
}

const DERS = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/DERS/Root'))
    })
}

const Survey = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/Survey/Root'))
    })
}

const MRT = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/MRT/Root'))
    })
}

const VisualPerception = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/VisualPerception/Root'))
    })
}

const DotProbe = (resolve) => {
    require.ensure([], () => {
        resolve(require('@/components/Tasks/DotProbe/Root'))
    })
}

Vue.use(Router)

const router = new Router({
    // mode: 'history',
    routes: [
        {
            path: '*',
            name: 'error',
            component: Error,
        },
        {
            path: '/',
            name: 'index',
            component: Login,
        },
        {
            path: '/auth/:projectID/:userID',
            name: 'lmi',
            component: LinkLogin,
        },
        {
            path: '/link/:token',
            name: 'lmi2',
            component: LinkTokenLogin,
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/error',
            name: 'error',
            component: Error,
        },
        {
            path: '/dash',
            name: 'dashboard',
            component: Dashboard,
        },
        {
            path: '/dsf',
            name: 'DigitSpanForwards',
            component: DigitSpanForwards,
        },
        {
            path: '/dsb',
            name: 'DigitSpanBackwards',
            component: DigitSpanBackwards,
        },
        {
            path: '/cod',
            name: 'Coding',
            component: Coding,
        },
        {
            path: '/srt',
            name: 'SimpleReactionTime',
            component: SimpleReactionTime,
        },
        {
            path: '/srtaudio',
            name: 'SimpleReactionTimeAudio',
            component: SimpleReactionTimeAudio,
        },
        {
            path: '/crt',
            name: 'ComplexReactionTime',
            component: ComplexReactionTime,
        },
        {
            path: '/pst',
            name: 'PatternSeparationTask',
            component: PatternSeparationTask,
        },
        {
            path: '/mst',
            name: 'MST',
            component: MST,
        },
        {
            path: '/ant',
            name: 'ant',
            component: ANT,
        },
        {
            path: '/vm',
            name: 'VerbalMemory',
            component: VerbalMemory,
        },
        {
            path: '/vismem',
            name: 'VisualMemory',
            component: VisualMemory,
        },
        {
            path: '/aborted',
            name: 'Aborted',
            component: Aborted,
        },
        {
            path: '/completed',
            name: 'completed',
            component: Completed,
        },
        {
            path: '/pvt',
            name: 'pictureVocabulary',
            component: PictureVocabularyTask,
        },
        {
            path: '/matrix',
            name: 'MatrixTest',
            component: Matrix,
        },
        {
            path: '/mat',
            name: 'MatrixTestIQT',
            component: iqtest,
        },
        {
            path: '/ptr',
            name: 'PatternRecognition',
            component: PatternRecognitionTest,
        },
        {
            path: '/hads',
            name: 'hads',
            component: HADS
        },
        {
            path: '/asrs',
            name: 'asrs',
            component: ASRS
        },
        {
            path: '/uppsp',
            name: 'uppsp',
            component: UPPSP
        },
        {
            path: '/russug',
            name: 'russug',
            component: RUSSUG
        },
        {
            path: '/audit',
            name: 'audit',
            component: AUDIT
        },
        {
            path: '/dudit',
            name: 'dudit',
            component: DUDIT
        },
        {
            path: '/cobra',
            name: 'cobra',
            component: COBRA
        },
        {
            path: '/cpfsurvey',
            name: 'cpfsurvey',
            component: CPFSurvey
        },
        {
            path: '/birthweightsurvey',
            name: 'birthweightsurvey',
            component: BWSurvey
        },
        {
            path: '/grit',
            name: 'grit',
            component: GRIT
        },
        {
            path: '/rand36',
            name: 'rand36',
            component: RAND36
        },
        {
            path: '/shortpersonalitytest',
            name: 'shortpersonalitytest',
            component: shortpersonalitytest
        },
        {
            path: '/personalitytest',
            name: 'personalitytest',
            component: personalitytest
        },
        {
            path: '/rewardandpunishment',
            name: 'rewardandpunishment',
            component: rewardandpunishment
        },
        {
            path: '/rrq',
            name: 'rrq',
            component: rrq
        },
        {
            path: '/rrs',
            name: 'rrs',
            component: rrs
        },
        {
            path: '/addiqol',
            name: 'addiqol',
            component: AddiQoL
        },
        {
            path: '/pretest',
            name: 'pretest',
            component: pretest
        },
        {
            path: '/posttest',
            name: 'posttest',
            component: posttest
        },
        {
            path: '/pretestfatigue',
            name: 'pretestfatigue',
            component: pretestfatigue
        },
        {
            path: '/posttestfatigue',
            name: 'posttestfatigue',
            component: posttestfatigue
        },
        {
            path: '/breakpoint',
            name: 'breakpoint',
            component: Breakpoint
        },
        {
            path: '/cpt',
            name: 'cpt',
            component: CPT
        },
        {
            path: '/stroop',
            name: 'stroop',
            component: Stroop
        },
        {
            path: '/stroope',
            name: 'stroope',
            component: StroopEmotional
        },
        {
            path: '/cptms',
            name: 'cptms',
            component: CPTMS
        },
        {
            path: '/cpt10',
            name: 'cpt10',
            component: CPT10
        },
        {
            path: '/cptaudio',
            name: 'cptaudio',
            component: CPTAUDIO
        },
        {
            path: '/cptaudio7',
            name: 'cptaudio7',
            component: CPTAUDIO7
        },
        {
            path: '/fingertappingtest',
            name: 'fingertappingtest',
            component: fingertappingtest
        },
        {
            path: '/synsoppfatningBlokk',
            name: 'synsoppfatningBlokk',
            component: SYNSOPPFATNINGBLOKK
        },
        {
            path: '/synsoppfatningBlokkMulti',
            name: 'synsoppfatningBlokkMulti',
            component: SYNSOPPFATNINGBLOKKMULTI
        },
        {
            path: '/synsoppfatningEvent',
            name: 'synsoppfatningEvent',
            component: SYNSOPPFATNINGEVENT
        },
        {
            path: '/psst',
            name: 'psst',
            component: PSST
        },
        {
            path: '/ders',
            name: 'ders',
            component: DERS
        },
        {
            path: '/survey',
            name: 'survey',
            component: Survey
        },
        {
            path: '/mrt',
            name: 'mrt',
            component: MRT
        },
        {
            path: '/visualPerception',
            name: 'visualPerception',
            component: VisualPerception
        },
        {
            path: '/dotProbe',
            name: 'dotProbe',
            component: DotProbe
        }
    ],
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js